import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../features/authentication/services/auth.service';

import {
  catchError,
  EMPTY,
  from,
  switchMap,
  throwError
} from 'rxjs';



export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);


  const isLoginRequest =
    req.url.endsWith('/api/v1/authentication/login');

  const isRefreshRequest =
    req.url.endsWith('/api/v1/authentication/refresh');

  const isLogoutRequest =
    req.url.endsWith('/api/v1/authentication/logout');

  if (
    isLoginRequest ||
    isRefreshRequest ||
    isLogoutRequest
  ) {
    return next(req);
  }

  return from(authService.getAccessToken()).pipe(
    switchMap(token => {
      
      if (!token) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
    }),
  );
};